module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Regular.ttf
// module id = 1578
// module chunks = 57